import { useReducer } from 'react'
import { getUnrefRefundReason } from '../../../../../helpers/refund'
import { refundStateReducer } from './reducer'
import { RefundState } from './types'

export const useServerRefundReducer = (
  originalRegisterSalePaymentIds?: string[],
  originalSalePaidByOtherPT?: boolean,
  disableUnrefRefund?: boolean
) => {
  const unrefRefundReason = getUnrefRefundReason(
    originalRegisterSalePaymentIds,
    originalSalePaidByOtherPT
  )
  const status = unrefRefundReason ? 'unreferencedPrompt' : 'creatingRefund'

  const initialState: RefundState =
    status === 'unreferencedPrompt'
      ? {
          status,
          unrefRefundReason: unrefRefundReason!,
        }
      : {
          status,
          consentCollected: false,
          disableUnrefRefund,
        }

  return useReducer(refundStateReducer, initialState)
}
